import _ from 'lodash';
import { FC } from 'react';
import Card from './Card';
import { brokerLogoCarouselConfig, testimonialDatas } from './config';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

import RibbleButton from 'v3/common/global/components/RibbleButton';

const Testimonial: FC = () => {
  const isMobile = useResponsive();
  return (
    <>
      <section className="testimonial">
        <h2>
          {isCrypto ? (
            'Testimonials'
          ) : (
            <>
              Trusted by <span>1,50,000+ Happy Traders</span>
            </>
          )}
        </h2>
        <div className="testimonial__content">
          {!isMobile && (
            <>
              <div className="right-blur" />
              <div className="left-blur" />
            </>
          )}
          <Splide options={brokerLogoCarouselConfig(isMobile)} extensions={isMobile ? {} : { AutoScroll }}>
            {_.map(testimonialDatas, (data, index) => (
              <SplideSlide key={`testimonial-${index}`}>
                <Card {...data} />
              </SplideSlide>
            ))}
          </Splide>
        </div>

        {!isCrypto && (
          <div className="testimonial__footer">
            <h3>Choose your plan. still not sure?</h3>
            <div className="divider d-lg-block d-md-none d-none"></div>
            <div className="gray-gradient-line d-lg-none d-md-block d-block"></div>
            <h3>
              We Offer <span>100 Backtest, 1 Live,</span> F&O and Equity
            </h3>
            <div className="divider d-lg-block d-md-none d-none"></div>
            <div className="gray-gradient-line d-lg-none d-md-block d-block"></div>
            <RibbleButton name="Start 7 day Pro Free Trial" onClick={() => window.openLoginModal()} />
          </div>
        )}
      </section>
    </>
  );
};

export default Testimonial;
